import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'beta-warning',
  templateUrl: './beta-warning.component.html',
  styleUrls: ['./beta-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, MatButtonModule],
})
export class BetaWarningComponent {
  @Output() agreeBetaOutput = new EventEmitter<boolean>();

  private _localStorageService = inject(LocalStorageService);

  public agree(): void {
    this._localStorageService.storeElement('agreeBeta', { value: true });
    this.agreeBetaOutput.emit(true);
  }

  public backToProd(): void {
    const currentUrl = window.location.href;
    const prodUrl = currentUrl.replace('-beta', '');
    window.location.replace(prodUrl);
  }
}
